import { debugLogs } from 'utils/common';

const observer = {
  instance: null,
  elements: new Map(),
  counter: 1,
};
//  web 10s timeout
const STICKY_TIMEOUT = 10;
const closeAtf = (atfAd, timer) => {
  try {
    if (atfAd.classList.contains('atf_sticky')) {
      atfAd.classList.add('up');
      if (timer) {
        clearTimeout(timer);
      }
      setTimeout(() => {
        atfAd.classList.remove('atf_sticky', 'up');
      }, 500);
    }
  } catch (e) {
    debugLogs(e);
  }
};
const unobserve = element => {
  try {
    if (observer.elements.size > 0) {
      observer.elements.delete(element);
      observer.instance.unobserve(element);
    }
    if (observer.counter < 1) {
      observer.instance.disconnect();
    }
  } catch (e) {
    debugLogs(e);
  }
};

const startAtfTimer = (atfAd, clback, timer) => {
  try {
    const adEvent = atfAd.getAttribute('data-adevent');

    if (
      adEvent !== 'slotRenderEnded' ||
      atfAd.classList.contains('atf_visited')
    ) {
      clback();
      return;
    }
    document.querySelectorAll('.atf_sticky').forEach(ele => {
      closeAtf(ele);
    });
    atfAd.classList.add('atf_sticky');
    // console.log('$$$$ 5', adEvent, atfAd.classList);
    observer[timer] = setTimeout(() => {
      atfAd.classList.add('atf_visited', 'up');
      closeAtf(atfAd, observer[timer]);
      // console.log('$$$$ 6', adEvent, atfAd.classList);
      clback();
      observer.counter -= 1;
    }, STICKY_TIMEOUT * 1000);
  } catch (e) {
    debugLogs(e);
  }
};
const createObserver = () => {
  try {
    if (!observer.instance) {
      observer.instance = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            const inView =
              entry.isIntersecting || entry.intersectionRatio > 0.5;
            const ele = observer.elements.get(entry.target);
            if (ele) {
              ele(inView, entry);
            }
          });
        },
        {
          root: null,
          rootMargin: '10px 0px 0px 0px',
          threshold: 0,
        },
      );
    }
  } catch (e) {
    debugLogs(e);
  }
};

function makeWebATFadSticky(element, callback) {
  try {
    if (
      typeof window !== 'undefined' &&
      typeof window.IntersectionObserver !== 'undefined'
    ) {
      createObserver();
      if (element && !observer.elements.has(element)) {
        observer.elements.set(element, callback);
        observer.instance.observe(element);
      }
    }
  } catch (e) {
    // debugLogs(e);
  }
}
export function processWebATFadSticky(event) {
  try {
    //removinig listener, as sticky is binded for this articleshow
    window.removeEventListener(
      'PROCESS_ATF_STICKY',
      processWebATFadSticky,
      false,
    );
    const _adDivElement = document.getElementById(event.detail.divId);
    const atfPrevElement =
      _adDivElement.previousElementSibling || _adDivElement.parentElement;
    makeWebATFadSticky(atfPrevElement, inView => {
      // console.log('$$$$ 1', inView, observer, _adDivElement);
      if (!inView) {
        startAtfTimer(
          _adDivElement,
          () => {
            unobserve(atfPrevElement);
          },
          'layout_timeout',
        );
      } else {
        closeAtf(_adDivElement);
      }
    });
  } catch (e) {
    // debugLogs(e);
  }
}
export function processPerpectualATFadSticky(atfad) {
  try {
    const atfElement = atfad?.querySelector('.atf_ad_perpetual');
    observer.counter = observer.counter > 1 ? observer.counter : 4;
    makeWebATFadSticky(atfad, (inView, entry) => {
      const elementRectBox = entry.boundingClientRect;
      const timO = `firstatfadti`;
      if (!inView && elementRectBox.bottom < 10) {
        startAtfTimer(
          atfElement,
          () => {
            unobserve(atfad);
          },
          timO,
        );
      } else {
        closeAtf(atfElement, timO);
      }
    });
  } catch (e) {
    // debugLogs(e);
  }
}
